import { Dialog, styled } from '@mui/material';

const StyledDialog = styled(Dialog)({
  '& .MuiDialogContent-root': {
    '& > .MuiList-root': {
      padding: 0,
      '& > .MuiListItem-root': {
        padding: 0,
        '& .MuiTypography-root': {
          fontSize: 14,
        },
      },
    },
  },
});

export default StyledDialog;
